import styled from 'styled-components'

import { breakpoint } from 'style/theme'

export default styled.div`
  width: 100%;
  height: 100%;

  .swiper {
    width: 100%;
    height: 100%;

    .swiper-pagination-bullets {
      bottom: 10px;
      .swiper-pagination-bullet {
        width: 9px;
        height: 9px;
        background-color: rgba(255, 255, 255, 0.7);
        opacity: 0.7;
        border-radius: 100%;
        opacity: 1;
        margin: 0 12px;
      }
      .swiper-pagination-bullet-active {
        background-color: rgba(129, 24, 17, 0.9);
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .swiper {
      .swiper-pagination-bullets {
        bottom: 10px;
        .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
          margin: 0 10px;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .swiper {
      .swiper-pagination-bullets {
        bottom: 10px;
        .swiper-pagination-bullet {
          width: 6px;
          height: 6px;
          margin: 0 6px;
        }
      }
    }
  }
`
